import { ContentHeader, Error } from 'mfa'
import Flex from '@talkdesk/cobalt-react-flex'
import Button from '@talkdesk/cobalt-react-button'
import IconWithProvider from '@talkdesk/cobalt-react-icon'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'

const ConfirmDialog = ({
  onDismiss,
  onConfirm,
  dismissText,
  confirmText,
  title,
  subtitle,
  errorMessage,
  isConfirmDisabled = false,
  isCancelDisabled = false,
}) => {
  const theme = useTheme()
  return (
    <Flex direction='column' alignX='center'>
      <Flex direction='column' alignX='center' padding='4' gap='2'>
        <IconWithProvider
          name='error_circle_outline'
          size='large'
          color={theme.gray500}
        />
        <Error message={errorMessage} />
        <ContentHeader title={title} message={subtitle} />
        <Flex gap='2' paddingTop='4'>
          <Button
            htmlType='button'
            type='secondary'
            onClick={onDismiss}
            disabled={isCancelDisabled}
          >
            {dismissText}
          </Button>
          <Button
            htmlType='button'
            type='danger'
            onClick={onConfirm}
            disabled={isConfirmDisabled}
          >
            {confirmText}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default ConfirmDialog
